export const properties = {

    baseURL: process.env.REACT_APP_API_URL || `http://localhost:8080/api`,

  jkaCardListPath:  `/jkacardfile`,
  affiliatesPath: `/affiliates`,
  affiliatesSummaryPath: `/affiliatessummary`,
  activeAffiliatePath: `/activeaffiliates`,
  affiliatesByStatePath: `/affiliates/state`,
  affiliatesByNamePath: `/affiliates/name`,
  activeAssociateAffiliatePath: `/activeassociateaffiliates`,
  blackBeltsPath:  `/blackbelts`,
  blackbeltsByNamePath: `/blackbelts/name`,
  blackbeltsStatePath: `/blackbelts/state`,
  blackBeltsSummaryPath:  `/blackbeltssummary`,
  addAnnuitiesByStatePath: `/annuities/stateid`,
  instructorsPath: `/instructors`,
  examinersPath: `/examiners`,
  judgesPath: `/judges`,
  teachersPath: `/teachers`,
  teachersSummaryPath: `/teacherssummary`,
  judgesMapsPath: `/judgesmaps`,

  blackBeltsSummaryOrderByNamePath:  `/blackbeltssummaryorderbyname`,

  gymsPath: `/gyms`,
  gymsAffiliatePath: `/gymsaffiliate`,

  blackBeltsDanXlsPath: `/blackbeltsdanxls`,
  blackBeltsListCSVPath: `/blackbeltsmincsv`,
  gymsCSVPath: `/gyms/csv`,
  judgesClassListCSVPath: `/judgesmincsv`,
  instructorsClassListCSVPath: `/instructorsmincsv`,
  examinersClassListCSVPath: `/examinersmincsv`,
  shihankaiListPath: `/shihankaimembersmincsv`,

  gymsUpdateGeoCodePath: `/gyms/updategeocode`,
  judgesUpdateGeoCodePath: `/judgessetmaps`,

  shihankaiMembersPath:  `/shihankaimembers`,
  gymsNotAffiliatePath: `/gymsnotaffiliate`,
  gymsStatePath: `/gyms/state`,
  judgelicensesPath: `/judgelicenses`,
  instructorlicensesPath: `/instructorlicenses`,
  affiliateAnnuitiesPath: `/affiliateannuities`,
  gymResponsiblesPath: `/gymresponsibles`,
  gymNameIdPath: `/gyms/name`,
  gymsNamePath: `/gyms/name`,
  gradesPath: `/grades`,
  statesPath: `/states`,
  dataPath: `/teacher/data`,
  gymResponsiblePath: `/gymresponsible`,
  gymAnnuitiesPath: `/annuities/`,

  gymLicensesPath: `/gymlicenses`,

  examinerlicensesPath: `/examinerlicenses`,
  danExamsPath: `/danexams`,
  coursesPath: `/courses`,
  coursesActivesPath: `/courses/actives`,
  coursesRegistrationAffiliatePath: `/coursesregistration/affiliate/`,

  adminEventsPath: `/admin/events`,
  adminEventRegistrationsPath: `/admin/events/registrations`,
  adminEventOrdersPath: `/admin/events/orders`,

  boardPositionsPath: `/board/positions`,
  boardTermsPath: `/board/terms`,
  boardMembersPath: `/board/members`,

};
